export default __webpack_public_path__ + "static/DMSerifText-Italic-a9c34fee60668888d0f877ca0e92a6c1.ttf";